import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import English translations
import enCommon from './locales/en/common.json'
import enSteps from './locales/en/steps.json'
import enAuth from './locales/en/auth.json'
import enErrors from './locales/en/errors.json'

// Import French translations
import frCommon from './locales/fr/common.json'
import frSteps from './locales/fr/steps.json'
import frAuth from './locales/fr/auth.json'
import frErrors from './locales/fr/errors.json'

export const SUPPORTED_LANGUAGES = ['en', 'fr'] as const
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number]

export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: 'English',
  fr: 'Français'
}

const resources = {
  en: {
    common: enCommon,
    steps: enSteps,
    auth: enAuth,
    errors: enErrors
  },
  fr: {
    common: frCommon,
    steps: frSteps,
    auth: frAuth,
    errors: frErrors
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'steps', 'auth', 'errors'],

    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false
    },

    react: {
      useSuspense: false
    }
  })

export default i18n
